import { useMutation } from '@tanstack/react-query';

import type { TransactionCategoryMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useTransactionCategoryActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<TransactionCategoryMutationResponse>({
        method: 'PATCH',
        url,
      }),
  });

export const useDeleteTransactionCategoryMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<TransactionCategoryMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });
